export default __webpack_public_path__ + "3ea52edc4dbadcdf7b7fce20f4297e8d.jpg";